import { render, staticRenderFns } from "./message-header.vue?vue&type=template&id=b0928972&scoped=true&"
import script from "./message-header.vue?vue&type=script&lang=js&"
export * from "./message-header.vue?vue&type=script&lang=js&"
import style0 from "./message-header.vue?vue&type=style&index=0&id=b0928972&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0928972",
  null
  
)

export default component.exports